import { render, staticRenderFns } from "./AttachFilePopup.vue?vue&type=template&id=3e60c1fe"
import script from "./AttachFilePopup.vue?vue&type=script&lang=js"
export * from "./AttachFilePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports